import StatusLabel from "~/components/StatusLabel";
import {Button, Pagination, Table, Tag} from "antd";
import {
	renderDate,
	numberFormat
} from "~/utils";
import ContractAction from "./ContractAction";
import {useDevice} from "~/hooks";
import ContractCustomerAction from "./ContractCustomerAction";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";
import {useSelector} from "react-redux";
import {currentUserSelector} from "~/features/Auth/authSlice";

function ContractTable({items = [], pagination, onPaginationChange, onChangeFilter, setItemEdit, openModal, can, handleDownload, handleAddDTLT}) {

	const {tableHeight} = useContext(AppContext);

	const {isMobile} = useDevice();

	//Cot Ngan sach quang cao chi danh cho ke toan & marketing
	const currentUser = useSelector(currentUserSelector);
	const userDept = currentUser?.department?.key;
	const canSeeBudget = ['accounting', 'marketing', 'marketingRenewal', 'marketingTechnical'].includes(userDept);

	const renderPercent = (price, amountRemaining) => {
		let percent = 0;
		let className   = "";
		if(amountRemaining === 0)
		{
			percent = 100;
			className = "color-green"
		}
		else if(amountRemaining === price) percent = 0;
		else percent = Math.round((price - amountRemaining)*100/price)

		return (
			<span className={className}>({percent}%)</span>
		)
	}

	const handleCustomerClick = (customerId) => {
		if (!onChangeFilter) return;
		onChangeFilter('customerId', customerId, true);
	}

	const handlePaperStatusClick = (item) =>
	{
		setItemEdit(item);
		openModal('paperStatus');
	}

	let columns = [
		{ title: 'Hợp đồng', dataIndex: 'code', key: "code", width: '400px', render: (_, item) => (
			<div>
				<b>{`${item?.code} ${item?.name}`}</b>
				<p>{isMobile && <Button onClick={() => handleCustomerClick(item.customerId)}><b style={{color : 'var(--primary)'}}>KH{item.customerId}</b></Button> } {item?.domain}</p>
				{isMobile &&
					<div>
						<StatusLabel small type={item.status?.badge}>{item.status?.label}</StatusLabel>
						<StatusLabel small type={item.service.badge}>{item.service?.label}</StatusLabel>
					&nbsp;<StatusLabel small type={item.service.badge}>{item.serviceType?.label}</StatusLabel>
					&nbsp;{(item?.package) && <StatusLabel small type={item.service?.badge}>{item?.package}</StatusLabel>}
					</div>
				}
			</div>
		)},
		{ title: 'Khách hàng', dataIndex: 'customer', key: "customer", width: '120px', render: (_, item) => (
			<ContractCustomerAction item={item} openModal={openModal} setItemEdit={setItemEdit} onChangeFilter={onChangeFilter}/>
		)},
		{ title: 'Phân công', dataIndex: 'user', key: "user", width: '250px', render: (_, item) => (
			<div>
				{item.user?.id && <p><Tag color={item?.user?.company?.badge}>{item?.user?.company?.label}</Tag> {`${item.user?.firstname} ${item.user?.lastname}`}</p>}
				{item.userShare?.id && <p><Tag color={item?.userShare?.company?.badge}>{item?.userShare?.company?.label}</Tag> {`${item.userShare?.firstname} ${item.userShare?.lastname}`}</p>}
			</div>
		)},
		{ title: 'Ngày ký', dataIndex: 'signing', key: "signing", width: '120px', render: (_, item) => (
			<div><p>{renderDate(item?.signing)}</p></div>
		)},
		{ title: 'Giá trị', dataIndex: 'price', key: "price", width: '180px', render: (_, item) => (
			<div>
				<p><b>{numberFormat(item?.price)}đ</b></p>
				<p className="color-grey">{(item?.amountRemaining == 0) ? 'Đã thanh toán' : numberFormat(item?.amountRemaining)} {renderPercent(item?.price, item?.amountRemaining)}</p>
			</div>
		)},
		{ title: 'Ngân sách', dataIndex: 'budget', key: "budget", width: '150px', render: (_, item) => (
			<div>
				<p><b>{(item?.budget > 0) ? numberFormat(item?.budget) + 'đ' : '-'}</b></p>
			</div>
		)},
		{ title: 'Dịch vụ', dataIndex: 'service', key: 'service', render:(_, item) => (
			<div>
				<StatusLabel small type={item.service?.badge}>{item.service?.label}</StatusLabel>
				&nbsp;
				{
					<StatusLabel small type={item.serviceType?.badge}>{item.serviceType?.label}</StatusLabel>
				}
				&nbsp;
				{
					(item?.package) && <StatusLabel small type={item.service?.badge}>{item?.package}</StatusLabel>
				}
			</div>
		)},
		{title: 'Trạng thái', dataIndex: 'status', key: "status", width: '140px', render: (_, item) => (
			<StatusLabel small type={item.status.badge}>{item.status.label}</StatusLabel>
		)},
		{title: 'Hợp đồng', dataIndex: 'paperStatus', key: "paperStatus", width: '140px', render: (_, item) => (
			<StatusLabel pointer onClick={() => handlePaperStatusClick(item)} small type={item.paperStatus.badge}>{item.paperStatus.label}</StatusLabel>
		)},
		{ title: '#', dataIndex: 'action', key: "action", width: '150px', render: (_, item) => (
			<ContractAction
				key={item.id}
				item={item}
				setItemEdit={setItemEdit}
				openModal={openModal}
				can={can}
				handleDownload={handleDownload}
				handleAddDTLT={handleAddDTLT}
			/>
		)},
	];

	if(isMobile) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'customer'
				&& currentValue.key !== 'status'
				&& currentValue.key !== 'service'
				&& currentValue.key !== 'budget'
			)
		})
	}

	if(!can.status) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'paperStatus')
		})
	}

	//Chi ke toan & marketing thay cot Ngan sach
	if(!canSeeBudget) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'budget')
		})
	}

	const dataSource= items.map(row => ({
		key: row.id, // I added this line
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} dataSource={dataSource} scroll={{ y:tableHeight, x: 'max-content' }} pagination={false} />
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default ContractTable;